import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Row } from '_zari/core'

import * as RolCrud from 'services/rol.service'

const RolesTab = ({ rolesSeleccionados }) => {
  const __zariContext = React.useContext(ZariContext)
  const [roles, setRoles] = React.useState([])

  React.useEffect(() => {
    RolCrud.getRoles_Select()
      .then(({ data }) => setRoles(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Row>
      <Col md={3} />
      <Col md={9}>
        {roles.map(x => (
          <React.Fragment key={x._id}>
            <Field name='_idsRoles'>
              {({ field }) => (
                <Form.Checkbox
                  {...field}
                  id={`check-${x.nombre}`}
                  label={x.nombre}
                  value={x._id}
                  checked={rolesSeleccionados.some(z => z === x._id)}
                />
              )}
            </Field>
          </React.Fragment>
        ))}
      </Col>
    </Row>
  )
}

export default React.memo(RolesTab)
